import { number, object, string } from 'yup';

export const illMemberSchema = object({
    id: number().required(),
    illness: string().required(),
    memberIndependence: number().required(),
    monthlyCostOfTreatment: string().required(),
    name: string().required(),
    note: string().nullable()
});

export const disabledMemberSchema = object({
    id: number().required(),
    reasonForDisability: string().required(),
    memberIndependence: number().required(),
    monthlyCostOfTreatment: string().required(),
    name: string().required(),
    note: string().nullable()
});
